// Helpers compartidos por las summary cards de los tabs (Resultados, Ventas,
// Gastos, Costos, Activos, No Operacional, Rentabilidad).

import { formatPercent, formatRangeLabel } from "./periodFormatting";

/**
 * Devuelve la card "vacía" usada como placeholder mientras el endpoint aún
 * no respondió (estado inicial post-mounted). El v-if del slot/template del
 * caller oculta los badges opcionales (mom, yoy, grossMargin, efficiency...)
 * mientras los strings extra estén vacíos — mostrar "—" o "0%" daría la
 * falsa señal de un dato calculado en cero.
 *
 * Cada caller puede sumar campos extra con `extra` sin reimplementar el
 * shape base. Ejemplo: `emptyCard({ efficiency: "" })` para NoOperTab.
 */
export function emptyCard(extra = {}) {
    return {
        period: "-",
        amount: 0,
        mom: "",
        yoy: "",
        progressItems: [],
        ...extra,
    };
}

/**
 * Construye la forma base de una summary card a partir del payload del backend.
 * Tabs específicos (Costos, Gastos) la componen con `...buildBaseCard(...)` y
 * suman sus campos propios (grossMargin, efficiency...) sin replicar el shape.
 *
 * - `colors` es la paleta del tab (COST_CARD_PROGRESS_COLORS, etc.); el item
 *   `i` del breakdown recibe `colors[i % colors.length]`.
 * - `showMom` controla si el badge MoM aparece — sólo aplica al mes actual.
 */
export function buildBaseCard(card, colors, { showMom = false } = {}) {
    return {
        period: formatRangeLabel(card.period_start, card.period_end),
        amount: card.amount,
        mom: showMom ? formatPercent(card.mom) : "",
        yoy: formatPercent(card.yoy),
        progressItems: (card.breakdown || []).map((item, i) => ({
            label: item.label,
            percent: item.percent,
            color: colors[i % colors.length],
        })),
    };
}
